import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

const API_BASE_PREFIX_STORAGE_KEY = 'api_base_prefix';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly candidateBaseUrls = [environment.apiBaseUrl];
  private activeBaseUrl = this.loadInitialBaseUrl();

  resolve(path: string) {
    return `${this.activeBaseUrl}${path}`;
  }

  get<T>(path: string, params?: Record<string, string>) {
    return this.request(path, (baseUrl) => this.http.get<T>(`${baseUrl}${path}`, { withCredentials: true, params }));
  }

  post<T>(path: string, body: unknown) {
    return this.request(path, (baseUrl) => this.http.post<T>(`${baseUrl}${path}`, body, { withCredentials: true }));
  }

  patch<T>(path: string, body: unknown) {
    return this.request(path, (baseUrl) => this.http.patch<T>(`${baseUrl}${path}`, body, { withCredentials: true }));
  }

  put<T>(path: string, body: unknown) {
    return this.request(path, (baseUrl) => this.http.put<T>(`${baseUrl}${path}`, body, { withCredentials: true }));
  }

  delete<T>(path: string) {
    return this.request(path, (baseUrl) => this.http.delete<T>(`${baseUrl}${path}`, { withCredentials: true }));
  }

  private request<T>(path: string, send: (baseUrl: string) => Observable<T>): Observable<T> {
    return send(this.activeBaseUrl);
  }

  private loadInitialBaseUrl(): string {
    if (typeof window === 'undefined') {
      return this.candidateBaseUrls[0] ?? '';
    }
    const storedBaseUrl = window.localStorage.getItem(API_BASE_PREFIX_STORAGE_KEY);
    if (storedBaseUrl !== null && this.candidateBaseUrls.includes(storedBaseUrl)) {
      return storedBaseUrl;
    }
    return this.candidateBaseUrls[0] ?? '';
  }

  private setActiveBaseUrl(baseUrl: string): void {
    this.activeBaseUrl = baseUrl;
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(API_BASE_PREFIX_STORAGE_KEY, baseUrl);
  }
}
